import { useContext, useState } from "react";

import { useTranslation } from "react-i18next";

import { PasswordIcon } from "@dotnet/telematics-design-system";

import { BUTTON_COLORS } from "components/DesignComponents/Button/types/enums";
import AuthContext from "context/auth/authContext";
import { L } from "shared/constants/dateFormats";
import { useDateTime } from "shared/hooks/useDateTime";

import ContentFrameGroup from "../../ContentFrameGroup";
import ChangePasswordModal from "./ChangePasswordModal";

const ChangePassword = () => {
    const { user } = useContext(AuthContext);

    const { t } = useTranslation();
    const { formattedDate } = useDateTime();

    const [isOpen, setIsOpen] = useState(false);

    const openDialog = () => setIsOpen(true);
    const closeDialog = () => setIsOpen(false);

    const passwordChangedAt = user?.password_changed_at;

    return (
        <>
            <ContentFrameGroup
                title={t("Security##password##settings##title")}
                description={t("Security##password##settings##description", {
                    date: passwordChangedAt
                        ? formattedDate(passwordChangedAt, L)
                        : "-"
                })}
                buttonText={t("Button##change")}
                buttonColor={BUTTON_COLORS.Secondary}
                icon={<PasswordIcon />}
                onButtonClick={openDialog}
            />

            <ChangePasswordModal isOpen={isOpen} close={closeDialog} />
        </>
    );
};

export default ChangePassword;
